<!-- 专科系列课 -->
<template>
    <div class="content">
        <div class="topImg">
            <img class="juniorCollegeTopImg" src="../../assets/images/juniorCollegeTopImg.png" alt="">

            <div class="collegeName">
                {{ specialty_name }}专科系统课
            </div>
            <div class="sloganeer">
                一个清单学透一个专科
            </div>
            <div class="UserCollegeInfo">
                <div class="infoItem">
                    <div class="num">
                        <span>{{ skill_count }}</span>专题
                    </div>
                    <div class="num">
                        {{ course_count }}节课程
                    </div>
                </div>
                <div class="infoItem">
                    <div class="num">
                        <span>{{ complete_count }}</span>节
                    </div>
                    <div class="num">
                        累计学完
                    </div>
                </div>
                <div class="infoItem">
                    <div class="num">
                        <span>{{ schedule }}</span>%
                    </div>
                    <div class="num">
                        已完成
                    </div>
                </div>
            </div>
        </div>
        
        
        <div class="courseListBox">
            <div class="courseListItem" v-for="(item, index) in courseTitleList" :key="index" @click="getSkillVideoList2(item,index)">
                <div class="courseListTitle">
                    {{ item.skill_name }}
                    <img class="titleIcon" :style="item.off?'transform: rotate(180deg);':''" src="../../assets/images/juniorCollegeIcon.png" alt="">
                </div>
                <div class="courseitemList" v-show="item.off">
                    <div class="courseitem" v-for="(item1, index1) in item.videoList" :key="index1" @click.stop="jumpVideoDetail(item1)">
                        <div class="courseTitle">
                            <img class="videoIcon" src="../../assets/images/juniorCollegeIcon1.png" alt="">
                            {{item1.videoName}}
                        </div>
                        <div class="hospital">
                            {{item1.teachers}}
                        </div>
                        <div class="courseTime">
                            {{item1.times}}分钟
                        </div>
                        <div class="download" @click.stop="downloadCourseware(item1)">
                            <img class="videoIcon" src="../../assets/images/juniorCollegeIcon2.png" alt="">
                            下载课件
                        </div>

                        <el-progress v-if="item1.jindu < 100" class="jdt" :show-text="false" :percentage="item1.jindu"></el-progress>
                        <img class="videoIcon" v-if="item1.jindu == 100" src="../../assets/images/juniorCollegeIcon3.png" alt="">
                        <div class="watchSchedule">
                            <span v-if="item1.jindu > 0 && item1.jindu < 100">
                                已观看{{item1.jindu}}%
                            </span>
                            <span v-if="item1.jindu == 0">
                                未观看
                            </span>
                            <span v-if="item1.jindu == 100" style="color:#00A870;">
                                已观看{{item1.jindu}}%
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        
        <div class="GradeStudyListBox">
            <div class="titles">专科系统课</div>
            <div class="gradeStudyList">
                <div class="gradeStudyItem" @click="jumpjuniorCollege(item)" v-for="(item, index) in SpectialtyDataList" :key="index">
                    <img class="itemIcon" :src="imgSrc + item.specialty_image" alt="">
                    <div class="itemInfo">
                        <div class="name">
                            {{ item.specialty_name }}
                        </div>
                        <div class="number">
                            {{ item.skill_count }}个专科,  {{ item.data_count }}节课程
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            imgSrc: "https://case.chongyike.com",
            // 专科名称
            specialty_name: "",
            // 专科ID
            specialtyId: 0,
            // 系列课数据
            courseTitleList: [],
            // 用户学习数据
            skill_count: 0,
            course_count: 0,
            complete_count: 0,
            schedule: 0,
            // 是否是会员
            isVip: false,
            // 专科列表
            SpectialtyDataList: [],
        }
    },
    created(){
    },
    mounted(){
        const that = this
        that.specialtyId = this.$route.params.id
        that.getUserVipTime()
		that.getSpectialtySkill()
        that.getSpectialtyLearningStatistics()
        that.getSpectialtyList()
    },
    watch: {
        $route(to, from){
            const that = this
            that.specialtyId = this.$route.params.id
            that.getUserVipTime()
            that.getSpectialtySkill()
            that.getSpectialtyLearningStatistics()
            that.getSpectialtyList()
        }
    },
	methods: {
        // 跳转视频详情
        jumpVideoDetail(item){
            const that = this
            var data = {
                dataType: 0,
                No: item.videoNo,
				name: item.videoName,
                classType: 1,
            }
            that.$router.push({
                path: '/videoDetail',
                query: {
                    text: that.encrypt(JSON.stringify(data))
                }
            })
        },
		// 跳转专科系列课
		jumpjuniorCollege(item){
			this.$router.push({
				path: "/juniorCollege/" + item.specialty_id,
			})
		},
        // 进度条方法
        format(percentage) {
            return percentage === 100 ? '满' : `${percentage}%`;
        },
        // 下载课件
        downloadCourseware(item){
            console.log(item.fileUrl);
            if(this.isVip){
                window.open(this.imgSrc + item.fileUrl)
            }else {
                this.$message({
                    showClose: true,
                    message: "请开通会员后下载课件",
                    type: 'success',
                    duration: 2000
                });
            }
        },
        // 获取会员信息
        getUserVipTime(){
            const that = this
            var data = {
                type: 'getUserVipTime',
            }
            this.get("/webhttp/mobileHandler", data, 1).then((res) => {
                if (res.data.code == "success") {
                    var result = res.data.result
                    if(result){
                        that.isVip = true
                    }
                }
            })
        },
        // 获取专科数据
		getSpectialtySkill(){
			const that = this
			var data = {
                type: "getSpectialtySkill",
				specialtyId: that.specialtyId
			}
			that.get('/webhttp/mobileHandler', data).then(res => {
                if (res.data.code == "success") {
                    var result = res.data.result
                    that.specialty_name = result.specialty_name
                    for (let i = 0; i < result.dataList.length; i++) {
                        result.dataList[i].off = false
                        var videoList  = result.dataList[i].videoList
                        for (let k = 0; k < videoList.length; k++) {
                            if(videoList[k].lookTimeLenght == null){
                                videoList[k].lookTimeLenght = 0
                            }
                            if(videoList[k].videoLength){
                                videoList[k].times = Math.ceil(videoList[k].videoLength/60)
                                videoList[k].jindu = Math.ceil((videoList[k].lookTimeLenght/videoList[k].videoLength)*100)
                            }else {
                                videoList[k].times = 0
                                videoList[k].jindu = 0
                            }
                        }
                    }
                    that.courseTitleList = result.dataList
                }
			})
		},
        // 获取用户专科信息
        getSpectialtyLearningStatistics(){
			const that = this
			var data = {
                type: "getSpectialtyLearningStatistics",
				specialtyId: that.specialtyId
			}
			that.get('/webhttp/mobileHandler', data, 1).then(res => {
                if (res.data.code == "success") {
                    var result = res.data.result
                    console.log(result)
                    that.skill_count = result.skill_count
                    that.course_count = result.course_count
                    that.complete_count = result.complete_count
                    if(result.video_complete_duration == null){
                        that.schedule = 0
                    }else {
                        that.schedule = Math.floor(result.video_complete_duration/result.video_total_duration*100)
                    }
                }
			})
        },
		// 获取专科系统课
		getSpectialtyList() {
			const that = this
			var data = {
                type: "getSpectialtyList",
			}
			that.get('/webhttp/mobileHandler', data, 1).then(res => {
                if (res.data.code == "success") {
                    var result = res.data.result
					that.SpectialtyDataList = result
                }
			})
		},
        // 展开收起
        getSkillVideoList2(item){
            const that = this
            item.off = !item.off
        },
    },
}
</script>

<style lang="scss" scoped>
.content {
    .topImg {
        position: relative;
        padding: 40px 35px;
        height: 310px;
        color: #fff;
        box-sizing: border-box;
        .juniorCollegeTopImg {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 310px;
            z-index: -1;
        }
        .collegeName {
            font-size: 34px;
            font-weight: 600;
            margin-bottom: 20px;
        }
        .sloganeer {
            font-size: 16px;
            margin-bottom: 40px;
        }
        .UserCollegeInfo {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 580px;
            height: 105px;
            border-radius: 10px;
            background-color: rgba(255,255,255,.3);
            .infoItem {
                flex: 1;
                display: flex;
                align-items: center;
                flex-direction: column;
                border-right: 1px solid #59A4FF;
                .num {
                    font-size: 18px;
                    span {
                        font-size: 32px;
                    }
                }
            }
        }
    }
    

    .courseListBox {
        margin-bottom: 20px;
        .courseListItem {
            margin-top: 20px;
			box-shadow: 0 0 10px 2px #eee;
            border-radius: 5px;
            .courseListTitle {
                position: relative;
                display: flex;
                align-items: center;
                height: 64px;
                font-size: 18px;
                font-weight: 600;
                padding: 0 15px;
                box-sizing: border-box;
                color: #464646;
                user-select: none;
                cursor: pointer;
                .number {
                    position: absolute;
                    right: 50px;
                    font-size: 15px;
                    color: #464646;
                    font-style: normal;
                }
                .titleIcon {
                    position: absolute;
                    right: 20px;
                    width: 14px;
                    height: 14px;
                    
                }
            }
            .courseitem {
                display: flex;
                align-items: center;
                height: 64px;
                font-size: 13px;
                color: #464646;
                padding: 0 15px;
                border-top: 1px solid rgba(221, 221, 221, 1);
                cursor: pointer;
                .videoIcon {
                    width: 15px;
                    height: 15px;
                    margin-right: 5px;
                }
                .courseTitle {
                    display: flex;
                    align-items: center;
                    width: 520px;
                    font-size: 16px;
                }
                .hospital {
                    width: 220px;
                }
                .courseTime {
                    width: 70px;
                }
                .download {
                    display: flex;
                    align-items: center;
                    width: 100px;
                    &:hover {
                        color: #206DAF;
                    }
                }
                .jdt {
                    width: 150px;
                }
                .watchSchedule {
                    width: 100px;
                    margin-left: 20px;
                }
                .max {
                    color: #aaa;
                }
            }
        }
    }

    
    .GradeStudyListBox {
        border-radius: 10px;
        margin-bottom: 20px;
        .titles {
            font-size: 26px;
            color: #444;
            height: 46px;
            padding: 20px;
        }
        .gradeStudyList {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            .gradeStudyItem {
                display: flex;
                align-items: center;
                width: 260px;
                height: 80px;
                padding-left: 30px;
                box-sizing: border-box;
                margin-bottom: 25px;
                border-radius: 5px;
                background-color: #fff;
                box-shadow: 0 0 10px 2px #eee;
                cursor: pointer;
                .itemIcon {
                    width: 50px;
                    margin-right: 20px;
                    margin-top: 10px;
                }
                .itemInfo {
                    display: flex;
                    flex-direction: column;
                    color: #333;
                    .name {
                        font-size: 16px;
                        padding-bottom: 6px;
                    }
                    .number {
                        font-size: 13px;
                    }
                }
            }
        }
    }
}
</style>